<template>
    <div>
        <div class="mainCarousel">
            <VueSlickCarousel v-bind="settings">
                <div class="mainBg1 hOver">
                    <div class="flexItem">
                        <div class="mainBgDistans">
                            <h2>
                                경희대학교<br class="mobileNotBr">
                                AgeTech연구소<br class="mobileNotBr">
                            </h2>
                            <h2>
                                경희대학교  <br class="mobileNotBr">
                                AgeTech연구소가 운영하는 <br class="mobileNotBr">
                                AgeTech Platform에 오신것을 환영합니다.
                            </h2>
                            <h2>
                                AGETECH PLATFORM
                            </h2>
                            
                        </div>
                        <div class="rowBtn1">
                            <a class="mainBgBtn startBtnFont" href="#section0">시작하기</a>
                        </div>
                    </div>
                </div>
                <div class="mainBg2 hOver">
                    <div class="flexItem">
                        <div class="mainBgDistans">
                            <h2>
                                경희대학교<br class="mobileNotBr">
                                AgeTech연구소는<br class="mobileNotBr">
                            </h2>
                            <h2>
                                시니어산업 분야의 <br class="mobileNotBr">
                                발전을 위해 기업과 소비자를 위한 <br class="mobileNotBr">
                                플랫폼 서비스입니다.
                            </h2>
                        </div>
                        <div class="mainOverlayBox"></div>
                        <div class="rowBtn1">
                            <a class="mainBgBtn startBtnFont" href="#section0">시작하기</a>
                        </div>
                    </div>
                </div>
                <div class="mainBg3 hOver">
                    <div class="flexItem">
                        <!-- <h1>뉴에이징 플랫폼</h1> -->
                        <div class="mainBgDistans">
                            <h2>
                                경희대학교<br class="mobileNotBr">
                                AgeTech연구소는<br class="mobileNotBr">
                            </h2>
                            <h2>
                                소비자에게 필요한 <br class="mobileNotBr">
                                맞춤형 고령친화제품과 서비스를 연결하고, <br class="mobileNotBr">
                                기업에게는 고객과 연결 및 새로운 비즈니스 <br class="mobileNotBr">
                                파트너를 만날 수 있도록 해드립니다.
                            </h2>
                        </div>
                        <div class="rowBtn1">
                            <a class="mainBgBtn startBtnFont" href="#section0">시작하기</a>
                        </div>
                    </div>
                </div>
                <div class="mainBg4 hOver">
                    <div class="flexItem">
                        <div class="mainBgDistans">
                            <h2>
                                경희대학교<br class="mobileNotBr">
                                AgeTech연구소는<br class="mobileNotBr">
                            </h2>
                            <h2>
                                고령자를 위한 <br class="mobileNotBr">
                                고령친화제품 및 서비스를 통해 <br class="mobileNotBr">
                                건강노화를 만들어갑니다.
                            </h2>
                        </div>
                        <div class="rowBtn1">
                            <a class="mainBgBtn startBtnFont" href="#section0">시작하기</a>
                        </div>
                    </div>
                </div>
            </VueSlickCarousel>

            <div class="scrollBtn">
                <img src="../../assets/images/cmmnMain/mainScrollIcon.png" alt="scroll btn">
            </div>
        </div>

        <!-- section 1 -->
        <section id="section0">
            <div class="inner row1R">
                <div class="mainSearchBox">
                    <h2>
                        찾으시는 제품/서비스를 검색해보세요
                    </h2>
                    <div class="mainSearchForm">
                        <input type="text" v-model="searchText" @keyup.enter="searchProductService" placeholder="찾으시는 제품과 서비스를 입력해주세요.">
                        <input type="button" @click="searchProductService">
                    </div>
                </div>
                <div class="mainBtn">
                    <button @click="goSelectProductCategory()">
                        <figure>
                            <img src="../../assets/images/cmmnMain/product_icon.png" alt="">
                            <figcaption>
                                고령친화제품
                                <span>(건강하고 편리한 생활에 도움이 되는 고령친화 맞춤형 제품)</span>
                            </figcaption>
                        </figure>
                    </button>
                    <button @click="goService()">
                        <figure>
                            <img src="../../assets/images/cmmnMain/service_icon.png" alt="">
                            <figcaption>
                                고령친화서비스
                                <span>(건강관리, 케어, 문화·여가 등 고령자 맞춤형 서비스)</span>
                            </figcaption>
                        </figure>
                    </button>

                    <ModalHomeCategory v-if="isShowModalHomeCategory"  @modal-closed='handleModalClosed'/>
                    <ModalHomeCategoryService v-if="isShowModalHomeCategoryService" @modal-closed='handleModalClosed'/>
                </div>
            </div>
        </section>

        <!-- section 2 -->
        <section>
            <div class="inner row2">
                <h1 class="mainTitle">서비스 소개</h1>
                <article class="serviceInfo">
                    <div class="inner aRow0 flex flexAlignCST">
                        <div class="serviceInfoImgBox">
                            <img src="../../assets/images/cmmnMain/corpnetwork.png" alt="기업 네트워킹 img">
                        </div>
                        <div class="contents">
                            <h2>기업 네트워킹</h2>
                            <h3>B2B 매치메이킹 맞춤형 파트너쉽 제공 </h3>
                            <router-link class="detailViewBtn" to="/corpNetworking">자세히 보기</router-link>
                        </div>
                    </div>
                </article>
                <article class="reverseFelxContent serviceInfo">
                    <div class="inner aRow0 flex flexAlignCST">
                        <div class="contents">
                            <h2>고령 소비자 서비스</h2>
                            <h3>고령소비자를 위한 맞춤형 제품·서비스 연결</h3>
                            <router-link class="detailViewBtn" to="/olderConsumers">자세히 보기</router-link>
                        </div>
                        <div class="serviceInfoImgBox">
                            <img src="../../assets/images/cmmnMain/oldcustomservice.png" alt="기업 네트워킹 img">
                        </div>
                    </div>
                </article>
                <article class="serviceInfo">
                    <div class="inner aRow0 flex flexAlignCST">
                        <div class="serviceInfoImgBox">
                            <img src="../../assets/images/cmmnMain/educationInfo.png" alt="기업 네트워킹 img">
                        </div>
                        <div class="contents">
                            <h2>교육·정보 제공</h2>
                            <h3>시니어산업 교육·정보 및 맞춤형컨설팅</h3>
                            <router-link class="detailViewBtn" to="/newagingcenter">자세히 보기</router-link>
                        </div>
                    </div>
                </article>
            </div>
        </section>

        <!-- section 3 -->
        <section>
            <div class="inner row2">
                <h1 class="mainTitle">협력기업</h1>
                <div class="aRow2">
                    <p class="alignC corpInfoTxt">
                      AgeTech Platform이 운영하는 고령친화산학협력 네트워크는 509여개의 다양한 분야의 기업과 네트워킹하고 있습니다.
                    </p>
                </div>
                <article>
                    <div class="inner aRow1">
                        <div class="corpSlide">
                            <carousel :items="1" :autoplay="true" :autoplayTimeout="3000" :dots="true" :nav="false" :loop="true">
                                <div class="flex partnerCorp1 corpPosition flexWrap">
                                    <div class="items corp1">
                                        <figure>
                                            <img src="../../assets/images/cmmnMain/logoSlide1.png" alt="">
                                        </figure>
                                    </div>
                                </div>
                                <div class="flex partnerCorp2 corpPosition flexWrap">
                                    <div class="items corp1">
                                        <figure>
                                            <img src="../../assets/images/cmmnMain/logoSlide2.png" alt="">
                                        </figure>
                                    </div>
                                </div>
                                <div class="flex partnerCorp3 corpPosition flexWrap">
                                    <div class="items corp1">
                                        <figure>
                                            <img src="../../assets/images/cmmnMain/logoSlide3.png" alt="">
                                        </figure>
                                    </div>
                                </div>
                                <div class="flex partnerCorp4 corpPosition flexWrap">
                                    <div class="items corp1">
                                        <figure>
                                            <img src="../../assets/images/cmmnMain/logoSlide4.png" alt="">
                                        </figure>
                                    </div>
                                </div>
                                <div class="flex partnerCorp5 corpPosition flexWrap">
                                    <div class="items corp1">
                                        <figure>
                                            <img src="../../assets/images/cmmnMain/logoSlide5.png" alt="">
                                        </figure>
                                    </div>
                                </div>
                            </carousel>
                        </div>
                    </div>
                </article>
                <div class="mobileTop mobileBlock">
                    <button>
                        <img src="../../assets/images/Btn/맨위로가기버튼.png" alt="">
                    </button>
                </div>
            </div>
            <div class="kakaoBtnCon">
                <a href="https://pf.kakao.com/_JBzSK" target='_blank'>
                    <div tabindex="0" class="kakaoBtnWrap">
                        <div class="kakaoImg">
                            <img alt="kakao btn" draggable="false" src="../../assets/images/Btn/kakaoBtnImg.png">
                        </div>
                        <div dir="auto" class="kakaoTxt">톡상담</div>
                    </div>
                </a>
            </div>
        </section>
    </div>  
</template>

<script>

import carousel from 'vue-owl-carousel'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import ModalHomeCategory from '@/components/category/ModalHomeCategory'
import ModalHomeCategoryService from '@/components/category/ModalHomeCategoryService'


export default {
    name: 'Home',
    components: {
        carousel,
        VueSlickCarousel,
        ModalHomeCategory,
        ModalHomeCategoryService
    },
    data() {
        return {
            isShowModalHomeCategory: false,
            isShowModalHomeCategoryService: false,
            settings: {
                dots:true,
                arrows:false,
                fade:true,
                speed:1500,
                infinite:true,
                autoplay:true,
                autoplaySpeed:5000,
                pauseOnDotsHover:true,
                pauseOnHover:true,
                "responsive": [
                    {
                    "breakpoint": 560,
                    "settings": {
                        "slidesToShow": 0.7,
                        "slidesToScroll": 1,
                    }
                    },
                ]
            },
            searchText : ''
        }
    },
    methods: {
        goSelectProductCategory() {
            this.isShowModalHomeCategory = true
        },
        goService() {
            this.isShowModalHomeCategoryService = true
        },
        handleModalClosed(value){
			if(value === ModalHomeCategory.name){
				this.isShowModalHomeCategory = false
			}
			if(value === ModalHomeCategoryService.name){
				this.isShowModalHomeCategoryService = false
			}
		},
        searchProductService(){
            if(!this.searchText){
                this.$alert('알림', '검색어를 입력해주세요.');
                return false;
            }
            this.$router.push({ path:'/serviceSearchResult', query: { searchText: this.searchText }})
        }
    }
}
</script>

<style scoped>
    .mainCarousel .hOver {
        height: calc(100vh - 10rem);
        min-height: 57.9rem;
    }
    .flexItem {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 50px;
        height: 100%;
    }
    @media screen and (max-width: 560px) {
        h2 {
            line-height: 29px;
        }
        .flexItem {
            padding: 0 20px;
        }
        .mainBg1 br {
            display: none;
        }
        .rowBtn1 {
            padding: 0;
        }
        .mainBgDistans {
            margin-bottom: 80px !important;
        }
        a.mainBgBtn {
            margin: 0 auto;
            width: 144px;
            font-size: 20px;
            line-height: 30px;
            padding: 3px 0;
        }
        .mainCarousel h1 {
            text-align: center;
            margin-bottom: 30px !important;
        }
        .mainCarousel h2 {
            text-align: center;
            line-height: 29px !important;
        }
        .inner.aRow0 {
            flex-direction: column;
        }
        .reverseFelxContent .flex.aRow0 {
            flex-direction: column-reverse;
        }
        .mainCarousel .hOver {
            height: calc(100vh - 60px);
        }
    }
</style>